import React from "react"
import PropTypes from "prop-types"

import ThemeConsumer from "../../../ThemeConsumer"

import { INVOICE_CLOSE_MODAL_BUTTON } from "shared/constants/idsElements"

const HeaderPrimary = ({ theme, icons, onClose }) => {
  return (
    <header className={theme.containerHeader}>
      <button onClick={onClose} id={INVOICE_CLOSE_MODAL_BUTTON}>
        <img src={icons.close.type} alt="Close" />
      </button>
    </header>
  )
}
HeaderPrimary.propTypes = {
  theme: PropTypes.shape({
    containerHeader: PropTypes.string
  }),
  icons: PropTypes.shape({
    close: PropTypes.node
  }),
  onClose: PropTypes.func.isRequired
}
export default ThemeConsumer("UIModernModal")(HeaderPrimary)



// WEBPACK FOOTER //
// ./src/shared/components/ModernModal/components/ModalHeader/HeaderPrimary.js